import React from "react";
import { Link } from "react-router-dom";

const ContinueShoppingButton = ({ className = "" }) => {
  return (
    <Link
      to="/products"
      className={`inline-flex items-center justify-center rounded-full bg-slate-950 px-5 py-3 text-sm font-semibold text-white transition hover:bg-slate-800 ${className}`}
    >
      Continue Shopping
    </Link>
  );
};

export default ContinueShoppingButton;
